import { useFieldArray, useFormContext, Controller, useWatch } from "react-hook-form";
import { Stack, Button, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { styles } from "../estimateStyle.tsx";
import { COMPARISION_COMPANY_IN_CHARGE_TYPE, EstimateDto, ROW_TYPE } from "./types.ts";
import React from "react";
import { SortableRow } from "../../layouts/SortableRow.tsx"
import ContentHeaderFields from "./ContentHeaderFields.tsx";
import CoverFieldsGrid from "./CoverFieldsGrid.tsx";
import ItemRowFields from "./ItemRowFields.tsx";
import PdfPreviewSlot from "./PdfPreviewSlot.tsx";
import SortableList from "./SortableList.tsx";
import { useFieldArrayDnd } from "./useFieldArrayDnd.ts";

interface EstimateFormProps {
    onNext: () => void;
    onPreview: () => void;
    onDownload: () => void;
    onReset: () => void;
    contentPdfBlob: Blob | null;
    loading: boolean;
}

export default function EstimateFormComparison({
    onNext,
    onPreview,
    onDownload,
    onReset,
    contentPdfBlob,
    loading
}: EstimateFormProps) {

    const { control, setValue } = useFormContext<EstimateDto>();
    const { fields, append, remove, move } = useFieldArray<
        EstimateDto,
        "content.items"
    >({ control, name: "content.items" });

    // remark 배열용 (comparison 폼은 remark 리스트를 렌더링하지 않지만,
    // RHF가 `content.remark` 필드 배열을 인식하도록 등록만 유지)
    const {
        append: appendRemark,
        } = useFieldArray<EstimateDto, "content.remark">({
        control,
        name: "content.remark",
        });


    const companyInCharge = useWatch({
            control,
            name: "companyInCharge"
        })

    React.useEffect(() => {
        setValue("companyInCharge", companyInCharge, { shouldValidate: true });
    }, [companyInCharge, setValue]);

    // � 드래그 센서 + 종료 핸들러 (items)
    const { sensors, handleDragEnd } = useFieldArrayDnd(fields, move);


    const addItem = () =>
        append({
            rowType: ROW_TYPE[0],
            item: "",
            size: "",
            unit: "",
            qty: 0,
            unitPrice: 0,
            amount: 0,
            remark: "",
            description: null
        })

    const addDesc = () =>
        append({
            rowType: ROW_TYPE[1],
            item: "",
            size: "",
            unit: "",
            qty: 0,
            unitPrice: 0,
            amount: 0,
            remark: "",
            description: ""
        })

    const addRemark = () =>
        appendRemark("")


    return (
        <div className="p-4 space-y-4">
            <form style={styles.form}>
            <h2 style={styles.heading}>견적서 본문 작성</h2>
                <Stack spacing={4}>
                    <CoverFieldsGrid />



                    <ContentHeaderFields />

                    {/* ------------- 드래그 가능한 리스트 ------------- */}
                    <SortableList
                        sensors={sensors}
                        onDragEnd={handleDragEnd}
                        ids={fields.map(f => f.id)}
                    >
                        {fields
                        .filter((item) => (item.description != null || item != undefined))
                        .map((item, index) => (
                            <SortableRow key={item.id} id={item.id}>
                                {
                                    <ItemRowFields
                                        index={index}
                                        remarkLabel="품목코드/비고"
                                        onRemove={() => remove(index)}
                                    />
                                }
                            </SortableRow>
                        ))}
                    </SortableList>

                    <Button onClick={ addItem }>
                        + 아이템 행 추가
                    </Button>

                    <Controller
                        name={`companyInCharge`}
                        control={control}
                        render={({ field }) => (
                            <RadioGroup
                                row
                                {...field}
                                onChange={(e) =>
                                    field.onChange(e.target.value)
                                    // handler
                                }>
                                {COMPARISION_COMPANY_IN_CHARGE_TYPE.map((value) =>
                                    <FormControlLabel
                                        value={value}
                                        control={<Radio />}
                                        label={value}
                                    />
                                )}
                            </RadioGroup>
                        )}
                    />

                </Stack>

            </form>

            <div
            className="space-x-2"
            style={{
            display: "flex",
            justifyContent: "flex-end", // ① 오른쪽 끝으로 밀기
            gap: "0.5rem",              // ② 버튼 간 간격(기존 space-x-2 대체)
            }}
            >
                <Button
                    onClick={onPreview}
                    style={styles.button}
                    >
                    미리보기 생성
                </Button>
                <Button
                    onClick={onDownload}
                    style={styles.button}>
                    다운로드
                </Button>
                <Button
                    onClick={onReset}
                    style={styles.button}
                    >
                    초기화
                </Button>

            </div>
            <div
            className="space-x-2"
            style={{
            display: "flex",
            justifyContent: "flex-end", // ① 오른쪽 끝으로 밀기
            gap: "0.5rem",              // ② 버튼 간 간격(기존 space-x-2 대체)
            }}
            >
            </div>

            <PdfPreviewSlot blob={contentPdfBlob} />
        </div>
    );
}
